import axios from "axios";

// 自动获取当前域名
const currentHost = window?.location?.host || "localhost";
const currentProtocol = window?.location?.protocol || "http:";

const dynamicApiPre = `${currentProtocol}//${currentHost}`;

// 获取基础API URL，优先使用环境变量，其次使用默认值
const BASE_URL = dynamicApiPre || process.env.VUE_APP_API_URL;

/**
 * 创建 axios 实例
 */
const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 10000, // 10秒超时
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * 获取Cookie
 */
function getCookie(name) {
  const cookieValue = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));
  return cookieValue ? cookieValue.split("=")[1] : null;
}

/**
 * 删除Cookie
 */
function removeCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

/**
 * 跳转登录页
 */
function redirectToLogin() {
  // 根据你的项目路由调整
  window.location.href = "/login";
}

/**
 * 请求拦截器 - 自动添加 Authorization token
 */
apiClient.interceptors.request.use(
  (config) => {
    // 从 Cookie 中获取 token
    const token = getCookie("token");
    // 如果 token 存在，添加到请求头
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * 响应拦截器
 */
apiClient.interceptors.response.use(
  (response) => {
    // 直接返回响应数据
    return response;
  },
  (error) => {
    // 统一错误处理
    console.error("API 请求错误:", error);
    // 401: token 失效或未登录
    if (error.response && error.response.status === 401) {
      removeCookie("token");
      redirectToLogin();
    }
    return Promise.reject(error);
  }
);

/**
 * GET 请求
 * @param {string} url - 请求地址
 * @param {Object} params - 请求参数
 * @param {Object} config - 配置项
 * @returns {Promise}
 */
export function get(url, params = {}, config = {}) {
  return apiClient.get(url, {
    params,
    ...config,
  });
}

/**
 * POST 请求
 * @param {string} url - 请求地址
 * @param {Object} data - 请求数据
 * @param {Object} config - 配置项
 * @returns {Promise}
 */
export function post(url, data = {}, config = {}) {
  return apiClient.post(url, data, config);
}

/**
 * PUT 请求
 * @param {string} url - 请求地址
 * @param {Object} data - 请求数据
 * @param {Object} config - 配置项
 * @returns {Promise}
 */
export function put(url, data = {}, config = {}) {
  return apiClient.put(url, data, config);
}

/**
 * DELETE 请求
 * @param {string} url - 请求地址
 * @param {Object} config - 配置项
 * @returns {Promise}
 */
export function del(url, config = {}) {
  return apiClient.delete(url, config);
}

export default {
  get,
  post,
  put,
  delete: del,
};
